export default "__VITE_ASSET__S34CSN45__"